import { Observable } from 'rxjs';
/**
 * Fork native rxjs fromEvent observer
 * compliant with EIP 1193
 * https://eips.ethereum.org/EIPS/eip-1193
 *
 * NgZone is required in order to handle Change Detection
 * correctly after receiving a message from the wallet browser extension.
 * */
export function fromEIP1193Event(target, eventName) {
    return new Observable((subscriber) => {
        const handler = (event) => {
            subscriber.next(event);
        };
        target.on(eventName, handler);
        return () => {
            if ('removeListener' in target) {
                return target.removeListener(eventName, handler);
            }
            console.warn('unable to unsubscribe from provider', target, eventName);
        };
    });
}
//# sourceMappingURL=from-eip1193-event.js.map